import { Pressable, StyleSheet, Text, View } from 'react-native';

import { fontSize, spacing } from '@/theme';

const variantColors = {
  info: {
    backgroundColor: '#d0ebff',
    textColor: '#1864ab',
  },
  warning: {
    backgroundColor: '#fff3bf',
    textColor: '#623300',
  },
  error: {
    backgroundColor: '#ffe3e3',
    textColor: '#a60a0a',
  },
} as const;

interface InlineBannerProps {
  readonly message: string;
  readonly variant: 'info' | 'warning' | 'error';
  readonly title?: string;
  readonly textAlign?: 'left' | 'center';
  readonly onDismiss?: () => void;
  readonly testID?: string;
}

export const InlineBanner = ({
  message,
  variant,
  title,
  textAlign = 'left',
  onDismiss,
  testID,
}: InlineBannerProps) => {
  const colors = variantColors[variant];

  return (
    <View style={[styles.container, { backgroundColor: colors.backgroundColor }]} testID={testID}>
      <View style={styles.content}>
        {title ? (
          <Text style={[styles.title, { color: colors.textColor, textAlign }]}>{title}</Text>
        ) : null}
        <Text style={[styles.message, { color: colors.textColor, textAlign }]}>{message}</Text>
      </View>
      {onDismiss ? (
        <Pressable
          onPress={onDismiss}
          hitSlop={8}
          accessibilityRole="button"
          accessibilityLabel="Dismiss">
          <Text style={[styles.dismissIcon, { color: colors.textColor }]}>✕</Text>
        </Pressable>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: spacing[3],
    alignSelf: 'stretch',
  },
  content: {
    flex: 1,
    gap: spacing[2],
  },
  title: {
    fontSize: fontSize.md,
    fontWeight: '700',
    letterSpacing: 0.15,
  },
  message: {
    fontSize: fontSize.sm,
    fontWeight: '400',
    letterSpacing: 0.15,
  },
  dismissIcon: {
    fontSize: fontSize.md,
    fontWeight: '500',
    marginLeft: 8,
  },
});
